import React from "react";

// Markdown-lite → JSX. Supports blank-line paragraphs, "- " bullet lists, and
// inline **bold**. Deliberately tiny — no markdown dependency (ponytail).

function renderInline(text, keyPrefix) {
  // Split on **bold** spans, keeping the delimiters out of the output.
  const parts = text.split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={`${keyPrefix}-b${i}`}>{part}</strong> : part
  );
}

export default function formatText(text) {
  const src = typeof text === "string" ? text : "";
  const blocks = src.split(/\n\n+/);
  const out = [];
  blocks.forEach((block, bi) => {
    const lines = block.split("\n");
    const isList = lines.every((l) => l.trim().startsWith("- "));
    if (isList) {
      out.push(
        <ul key={`ul-${bi}`} className="help-guide__list">
          {lines.map((l, li) => (
            <li key={`li-${bi}-${li}`}>
              {renderInline(l.replace(/^\s*-\s+/, ""), `li-${bi}-${li}`)}
            </li>
          ))}
        </ul>
      );
    } else {
      out.push(
        <p key={`p-${bi}`} className="help-guide__p">
          {renderInline(block, `p-${bi}`)}
        </p>
      );
    }
  });
  return out;
}
